import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { joinList } from '../lib/subscribers';

export default function JoinList({ cities = [] }) {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [city, setCity] = useState('');
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    if (!consent) { setStatus('error'); setMessage('Please agree to receive updates before joining.'); return; }
    setStatus('submitting'); setMessage('');
    try {
      await joinList({ email, phone, city });
      setStatus('done'); setEmail(''); setPhone(''); setCity(''); setConsent(false);
    } catch (error) {
      setStatus('error'); setMessage(error.message || 'Something went wrong. Try again.');
    }
  };

  return <section style={styles.section} aria-labelledby="join-list-heading">
    <div style={styles.box}>
      <div>
        <p style={styles.eyebrow}>Never miss an event</p>
        <h2 id="join-list-heading" style={styles.heading}>Join the List</h2>
        <p style={styles.copy}>Hear about new events across Kerala first, by email or phone.</p>
      </div>
      {status === 'done' ? <p style={styles.done}>You're on the list. Welcome to Malluland!</p> : <form onSubmit={submit} style={styles.form}>
        <div style={styles.fields}>
          <input type="email" required placeholder="Email address" value={email} onChange={(event) => setEmail(event.target.value)} style={styles.input} />
          <input type="tel" placeholder="Phone (optional)" value={phone} onChange={(event) => setPhone(event.target.value)} style={styles.input} />
          <select value={city} onChange={(event) => setCity(event.target.value)} style={styles.input}>
            <option value="">Any city</option>
            {cities.map((item) => <option key={item} value={item}>{item}</option>)}
          </select>
        </div>
        <label style={styles.consentLabel}>
          <input type="checkbox" checked={consent} onChange={(event) => setConsent(event.target.checked)} style={styles.checkbox} />
          <span>I agree to receive event listings and updates from Malluland by email and text message. Unsubscribe anytime.</span>
        </label>
        {message && <p style={{ ...styles.copy, color: status === 'error' ? '#ff8a80' : '#9ce8b0', margin: 0 }}>{message}</p>}
        <button type="submit" disabled={status === 'submitting'} style={styles.button}>{status === 'submitting' ? 'Joining…' : <>Join the List <ArrowUpRight size={17} /></>}</button>
      </form>}
    </div>
  </section>;
}

const styles = {
  section: { maxWidth: 1120, margin: '0 auto 5rem', padding: '0 1.5rem' },
  box: { background: '#111', color: '#fff', borderRadius: 16, padding: '2.5rem', display: 'grid', gridTemplateColumns: 'minmax(240px, 1fr) minmax(280px, 1fr)', gap: 32, alignItems: 'center' },
  eyebrow: { color: '#bbb', textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 700, fontSize: '0.72rem', margin: 0 },
  heading: { color: '#fff', fontSize: 'clamp(1.8rem, 3vw, 2.6rem)', letterSpacing: '-0.04em', margin: '0.35rem 0 0.75rem' },
  copy: { color: '#ccc', lineHeight: 1.55, margin: 0, maxWidth: 460 },
  done: { color: '#9ce8b0', fontWeight: 700, fontSize: '1.05rem', margin: 0 },
  form: { display: 'grid', gap: 12 },
  fields: { display: 'grid', gap: 10 },
  input: { width: '100%', boxSizing: 'border-box', background: '#1c1c1c', color: '#fff', border: '1px solid #333', borderRadius: 8, padding: '0.8rem 0.9rem', font: 'inherit', fontSize: '0.95rem' },
  consentLabel: { display: 'flex', gap: 9, alignItems: 'flex-start', color: '#aaa', fontSize: '0.76rem', lineHeight: 1.4 },
  checkbox: { marginTop: 3, flexShrink: 0 },
  button: { background: '#fff', color: '#111', border: 0, borderRadius: 8, padding: '0.85rem', font: 'inherit', fontWeight: 800, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6 },
};
